import { Typography } from '@mui/material';

import { useUnreadNotificationCount } from 'features/notifications/lib/NotificationFeedContext';
import { unreadNotificationsLabel } from 'features/notifications/lib/unreadNotificationsLabel';
import { NotificationsList } from 'features/notifications/ui/NotificationsList';
import { useOnboardingDialogStore } from 'features/onboarding/lib/useOnboardingDialogStore';
import type { PaneSlot } from 'features/onboarding/ui/ControlCenterPane';
import { PaneList, PaneStrip } from 'features/onboarding/ui/ControlCenterPane';

/** The notification feed, as the Notifications tab's pane. */
export function useNotificationsPane(): PaneSlot {
  const isExpanded = useOnboardingDialogStore((state) => state.expanded.notifications);
  const setExpanded = useOnboardingDialogStore((state) => state.setExpanded);
  const unreadCount = useUnreadNotificationCount();
  // Someone opening this tab has come to read the feed, so it starts expanded.
  const listOpen = isExpanded ?? true;

  return {
    isListOpen: listOpen,
    onAsk: () => setExpanded('notifications', false),
    strip: (
      <PaneStrip isListOpen={listOpen} onToggle={() => setExpanded('notifications', !listOpen)}>
        <Typography className="truncate font-medium text-grey90 text-sm">
          {unreadNotificationsLabel(unreadCount) ?? 'No unread notifications'}
        </Typography>
      </PaneStrip>
    ),
    list: (
      <PaneList isOpen={listOpen} label="Notifications">
        <NotificationsList />
      </PaneList>
    ),
  };
}
